import { GET_ASSESSMENT_TEST_DETAILS,GET_ASSESSMENT_TEST_DETAILS_SUCCESS,GET_ASSESSMENT_TEST_DETAILS_FAILED,FINISH_ASSESSMENT_TEST,FINISH_ASSESSMENT_TEST_SUCCESS,FINISH_ASSESSMENT_TEST_FAILED,GET_ASSESSMENT_TEST_QUESTIONS,GET_ASSESSMENT_TEST_QUESTIONS_SUCCESS,GET_ASSESSMENT_TEST_QUESTIONS_FAILED } from "./actionTypes";

export const getAssessmentTestDetails = (data)=>{
    return {
        type: GET_ASSESSMENT_TEST_DETAILS,
        payload: data
    }
} 

export const getAssessmentTestDetailsSuccess = (data)=>{
    return {
        type:GET_ASSESSMENT_TEST_DETAILS_SUCCESS,
        payload: data
    }
} 

export const getAssessmentTestDetailsFailed = (error)=>{
    return {
        type:GET_ASSESSMENT_TEST_DETAILS_FAILED,
        payload: error
    }
} 

export const getAssessmentTestQuestions = (data)=>{
    return {
        type: GET_ASSESSMENT_TEST_QUESTIONS,
        payload: data
    }
} 

export const getAssessmentTestQuestionsSuccess = (data)=>{
    return {
        type:GET_ASSESSMENT_TEST_QUESTIONS_SUCCESS,
        payload: data
    }
} 

export const getAssessmentTestQuestionsFailed = (error)=>{
    return {
        type:GET_ASSESSMENT_TEST_QUESTIONS_FAILED,
        payload: error
    }
} 



export const finishAssessmentTest = (data)=>{
    return {
        type: FINISH_ASSESSMENT_TEST,
        payload: data
    }
} 

export const finishAssessmentTestSuccess = (data)=>{
    return {
        type:FINISH_ASSESSMENT_TEST_SUCCESS,
        payload: data
    }
} 

export const finishAssessmentTestFailed = (error)=>{
    return {
        type:FINISH_ASSESSMENT_TEST_FAILED,
        payload: error
    }
} 